import {Component, NgZone, OnInit, ViewChild} from '@angular/core';
import {IonSearchbar, ModalController, NavParams} from '@ionic/angular';
import {AddressModel} from '../../../../../core-logic/models/address/address-model';

declare let google;
@Component({
    selector: 'app-location-selector',
    templateUrl: './location-selector.component.html',
    styleUrls: ['./location-selector.component.scss'],
})
export class LocationSelectorComponent implements OnInit {
    @ViewChild('searchbar') searchbar: IonSearchbar;
    autocompleteInput: string;
    autocompleteOutput = [];
    GoogleAutocomplete: any;
    selectedLocation: AddressModel = {} as AddressModel;
    protected loadingInProgress = false;

    constructor(private ngZone: NgZone, private modalCtrl: ModalController, navParams: NavParams) {
        this.autocompleteInput = navParams.get('inputValue') ? navParams.get('inputValue') : '';
        this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
        this.updateSearchResults();
    }

    ionViewDidEnter() {
        setTimeout(() => {
            this.searchbar.setFocus();
        }, 500);
    }

    ngOnInit(): void {
    }

    updateSearchResults() {
        this.loadingInProgress = true;
        if (this.autocompleteInput === '') {
            this.ngZone.run(() => {
                this.loadingInProgress = false;
                this.autocompleteOutput = [];
            });
            this.selectedLocation = {} as AddressModel;
            return;
        }
        this.GoogleAutocomplete.getPlacePredictions({ input: this.autocompleteInput, types : [] },
            (predictions, status) => {
                if (predictions && status === 'OK') {
                    this.ngZone.run(() => {
                        this.loadingInProgress = false;
                        this.autocompleteOutput = predictions;
                    });
                } else {
                    this.ngZone.run(() => {
                        this.loadingInProgress = false;
                        this.autocompleteOutput = [];
                    });
                }
            });
    }

    clear() {
        this.autocompleteInput = '';
        this.autocompleteOutput = [];
    }

    close() {
        this.autocompleteInput === '' ? this.modalCtrl.dismiss() : this.modalCtrl.dismiss({} as AddressModel);
    }

    selectLocation(place: any) {
        const geocoder = new google.maps.Geocoder();
        if (place && place.place_id) {
            geocoder.geocode({ placeId: place.place_id}, (results, status) => {
                this.selectedLocation = {} as AddressModel;
                if (results && status === 'OK') {
                    this.selectedLocation.google_place_id = results[0].place_id;
                    this.selectedLocation.formatted_address = results[0].formatted_address;
                    this.selectedLocation.geometry = {lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() };
                    this.selectedLocation.location = {type: 'Point', coordinates: [
                      this.selectedLocation.geometry.lng,
                        this.selectedLocation.geometry.lat
                      ]
                    };
                    results[0].address_components.forEach( addressComponent => {
                        if (addressComponent.types.includes('country')) {
                            this.selectedLocation.country = addressComponent.long_name;
                        }

                        if (addressComponent.types.includes('locality')) {
                            this.selectedLocation.city = addressComponent.long_name;
                        }

                        if (addressComponent.types.includes('postal_code')) {
                            this.selectedLocation.zip_code = addressComponent.long_name;
                        }

                        if (addressComponent.types.includes('street_number')) {
                            this.selectedLocation.street_number = addressComponent.long_name;
                        }

                        if (addressComponent.types.includes('route')) {
                            this.selectedLocation.route = addressComponent.long_name;
                        }
                    });
                    if (!this.selectedLocation.city) {
                      const addressComponent = results[0].address_components.find(addressComponent => addressComponent.types
                        .includes('administrative_area_level_1'));
                      this.selectedLocation.city = addressComponent.long_name;
                    }
                    this.modalCtrl.dismiss(this.selectedLocation);
                }
            });
        }
    }
}
